import React from 'react';
import { QuestionManagement } from '@/components/questions/QuestionManagement';

const QuestionsPage: React.FC = () => {
  return <QuestionManagement />;
};

export default QuestionsPage;
